(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-brands"] && !Shopify.designMode) return;
  try {
    
  const all_letters = document.querySelectorAll('.brands-letter');
  all_letters.forEach((letter) => {
    const id = letter.id;
    const corresponding_href = document.querySelector(`a[href="#${id}"]`);
    const brands = letter.querySelector('.brands');
    if (brands.children.length === 0) {
      letter.style.display = 'none';
      corresponding_href.style.display = 'none';
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  const filtersWrapper = document.querySelector('aside');
  if (filtersWrapper.classList.contains('sticky')) {
    let header = document.querySelector('sticky-header') || document.querySelector('div:has(header)');
    let headerHeight = header.clientHeight;
    if (header.getAttribute('data-sticky-type') == 'on-scroll-up') {
      window.addEventListener('wheel', function(event) {
        if (event.deltaY < 0) { // scroll up
          filtersWrapper.style.top = headerHeight + 'px';
        } else { // scroll down
          filtersWrapper.style.top = '';
        }
      });
    } else {
      if (header.tagName === 'DIV') {
        headerHeight = 0;
      }
      window.addEventListener('scroll', function() {
        if (document.querySelector('.section-header').classList.contains('scrolled-past-header')) {
          let headerHeight = header.clientHeight;
          filtersWrapper.style.top = headerHeight + 'px';
        }
      });
    }

// hides header when mobile filters menu is open
    const menuDrawer = filtersWrapper.querySelector('menu-drawer > details.mobile-facets__disclosure');
    if (menuDrawer) {
      const stickyHeader = document.querySelector('sticky-header');
      const updateHeaderDisplay = () => {
        if (menuDrawer.hasAttribute('open')) {
          stickyHeader.style.display = 'none';
        } else {
          stickyHeader.style.display = 'block';
        }
      };
      updateHeaderDisplay();
      const observer = new MutationObserver(updateHeaderDisplay);
      observer.observe(menuDrawer, {
        attributes: true,
        attributeFilter: ['open']
      });
    }
  }

  } catch(e) { console.error(e); }
})();
})();
